import { render, staticRenderFns } from "./CCreatedAt.vue?vue&type=template&id=a6a2fdce&scoped=true&"
import script from "./CCreatedAt.vue?vue&type=script&lang=js&"
export * from "./CCreatedAt.vue?vue&type=script&lang=js&"
import style0 from "./CCreatedAt.vue?vue&type=style&index=0&id=a6a2fdce&prod&lang=css&"
import style1 from "./CCreatedAt.vue?vue&type=style&index=1&id=a6a2fdce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a2fdce",
  null
  
)

export default component.exports